<template>
  <div>
    <v-dialog v-model="dialog" max-width="900px">
      <v-card>
        <v-card-title class="blue darken-3 white--text">
          <span class="text-h5"> Asignar Unidad </span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-select
              v-model="nuevo.unidad_negocio_id"
              :items="unidades"
              :loading="loadingunidades"
              label="* Unidad de negocio"
              item-value="id"
              class="mt-6 mb-4"
              outlined
              dense
              hide-details
            />

            <v-row no-gutters>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model.trim="nuevo.cuenta_contable"
                  label="* codigo contable"
                  class="mt-0 mr-2"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model.trim="nuevo.descripcion_cuenta_contable"
                  label="* Desc codigo contable"
                  class="mt-0 ml-2"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4" md="6">
                  <v-select
                    v-model="nit_sel"
                    :items="nits"
                    item-text="xtext"
                    label="Seleccione el nit"
                    :readonly="isedit"
                    :color="isedit?'grey':''"
                    return-object
                    class=""
                    outlined
                    dense
                    hide-details
                  />
                </v-col>
              <v-col cols="12" sm="4" md="6"> 
                  <v-select
                    v-model="nuevo.actividad_economica_sin"
                    :items="uactividades"
                    :loading="loadingactividades" 
                    item-value="codigo"
                    label="Actividad" 
                    outlined
                    dense
                    hide-details
                  />
                </v-col>
                <v-col cols="12" sm="4" md="6">
                  <v-select
                    v-model="nuevo.codigo_sin"
                    :items="uproductos"
                    :loading="loadingproductos"
                    item-value="codigoProductoServicio"
                    label="Codigo SIN (Segun actividad)"
                    class="mr-2"
                    outlined
                    dense
                    hide-details
                  />
                </v-col>
                <v-col cols="12" sm="4" md="6">
                  <v-select
                    v-model="nuevo.codigo_documento_sector"
                    :items="docssector"
                    :disabled="!nuevo.actividad_economica_sin"
                    label="Documento Sector"
                    item-value="id"  
                    outlined
                    dense
                    hide-details
                  />
                </v-col>
                <!--  -->
                <v-col cols="12" sm="12" md="12">
                  <buscarCaja ref="refBuscarCaja"/>
                </v-col>
            </v-row>
          </v-container> 

          <p class="text-center red--text">{{ msg }}</p>
          <v-progress-linear indeterminate v-if="loading" />

         
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-3" class="white--text" @click="dialog = !dialog">
            Cerrar
          </v-btn>
          <v-btn color="green darken-3" class="white--text" :disabled="loading" @click="save">
            {{ isedit ? 'Actualizar' : 'Guardar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import gql from 'graphql-tag';
  import buscarCaja from './buscarCaja.vue'
  export default {
    components:{ buscarCaja },
    data: () => ({
      dialog: false,
      loading: false,
      loadingunidades: false,
      msg: '',
      unidades: [],
      nuevo: {
        concepto_pago_id: 1,
        unidad_negocio_id: 27,

        cuenta_contable: null,
        descripcion_cuenta_contable: null,
        isedit: false,
        //nuevo
        actividad_economica_sin: null,
        codigo_sin: null,
        codigo_documento_sector: null,
        nit_id: null,
      },
      isedit: false,
      // nuevo 
      uproductos: [],
      uproductoscopy: [],
      uactividades: [], 
      //docsector: null,
      //actividad: null,
      nits: [],
      nit_sel: null,
      //prod_sel: null,
      
      docssector: [
        { id: 1, text: 'COMPRA Y VENTA' },
        { id: 11, text: 'SECTOR EDUCATIVO' },
        { id: 46, text: 'SECTOR EDUCATIVO ZONA FRANCA' },
        // monto sujeto iva cuando es  46 
      ], 
      loadingproductos: false,
      loadingactividades: false,
      xitem: {},
    }),

    watch:{
      'nuevo.actividad_economica_sin': function() { 
        this.uproductos = this.uproductoscopy.filter((x) => {
          return x.codiigoActividad == this.nuevo.actividad_economica_sin;
        });
        //window.console.log(a.codigo, a.codigo == '620200');
        let a = this.nuevo.actividad_economica_sin;
        this.nuevo.codigo_documento_sector = null;
        if (a == '620200') this.nuevo.codigo_documento_sector = 1;
        else if (a == '620000') this.nuevo.codigo_documento_sector = 1;
        else if (a == '853000') this.nuevo.codigo_documento_sector = 11;
        else this.nuevo.codigo_documento_sector = 46;
        // this.nuevo.codigo_documento_sector = this.docsector;
        //this.nuevo.actividad_economica_sin = parseInt(this.actividad.codigo);
      },
      nit_sel: function() {
        // window.console.log(this.nit_sel);
        if(this.nit_sel){
          this.getactividades(this.nit_sel.apikey);
          this.productosservicios(this.nit_sel.apikey);
        }
      },
    },

    methods: {
      async openmodal(item) {
        window.console.log('openmodal:::',item);
        this.xitem = {};
        this.msg = '';
        this.nit_sel = null;
        let idconcepto = this.$route.query.idconcepto;
        this.nuevo.concepto_pago_id = parseInt(idconcepto);
        this.nuevo.unidad_negocio_id = null;
        this.nuevo.cuenta_contable = null;
        this.nuevo.descripcion_cuenta_contable = null;
        this.nuevo.actividad_economica_sin = null;
        this.nuevo.codigo_sin = null;
        this.nuevo.codigo_documento_sector = null;
        this.isedit = false;
        this.dialog = true;
        await this.getNits();
        if(item) this.$refs.refBuscarCaja.reset(item.cuenta_netsuite);
        else this.$refs.refBuscarCaja.reset();
        await this.getactividades(this.$store.getters.getApiKey);
        if (item) {
          // window.console.log('edit concepto:',item);
          this.xitem = JSON.parse(JSON.stringify(item));
          await this.getConceptoUnidad(this.nuevo.concepto_pago_id,item.unidad_negocio_id);
          this.nuevo.concepto_pago_id = item.concepto_pago_id;
          this.nuevo.unidad_negocio_id = item.unidad_negocio_id;
          this.nuevo.cuenta_contable = item.cuenta_contable;
          this.nuevo.descripcion_cuenta_contable = item.descripcion_cuenta_contable;
          this.isedit = true;
        }
        
        this.loading = false;
        this.getunidades();
        this.productosservicios(this.$store.getters.getApiKey);
        
      },
      async getunidades() {
        var vue = this;
        this.loadingunidades = true;
        let s = `query { NegociosAll { id nombre } }`;
        var sql = gql`
          ${s}
        `;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var dat = data.data.NegociosAll;
            dat.map((x) => {
              x.text = x.nombre;
            });
            vue.unidades = dat;
            vue.loadingunidades = false;
          })
          .catch((error) => {
            vue.loadingunidades = false;
            window.console.error(error);
          });
      },
      async getactividades(xapikey) {
        this.loadingactividades = true;
        this.uactividades = [];
        //this.actividad = null;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/actividad`,
          headers: {
            apikey: xapikey,
          },
        };

        let response = await xaxios.request(config).then(x=>x).catch(e=>e);
        let data = response.data;
        if(!data) data = [];
          window.console.log("acts:", data);
          data.map((u) => {
            u.id = u.codigo;
            u.text = `(${u.codigo}) ${u.descripcion}`;
          });
          let d = data.find((x) => x.id == vue.nuevo.codigo_actividad);
          if(d) vue.nuevo.actividad_economica_sin = d.codigo;
          vue.uactividades = data;
          vue.loadingactividades = false;
      },
      productosservicios(xapikey) {
        this.loadingproductos = true;
        this.uproductos = [];
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/productosservicios`,
          headers: {
            apikey: xapikey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            /*data = data.filter((x) => {
              return x.codiigoActividad == '853000';
            });*/
            data = data.sort((a, b) => {
              let x = a.codigoProductoServicio;
              let y = b.codigoProductoServicio;
              let f = 0;
              if (x > y) f = 1;
              else if (x < y) f = -1;
              return f;
            });
            data.map((u) => {
              //u.codigoProductoServicio = '' + u.codigoProductoServicio;
              u.codigoProductoServicio = parseInt(u.codigoProductoServicio);
              u.id = u.codigoProductoServicio; 
              // u.text = `(${u.codigoProductoServicio}) ${u.tipoActividad} [${u.descripcion}]`;
              u.text = `(${u.codigoProductoServicio}) [${u.descripcion}]`;
              vue.uproductoscopy.push(u);
            });
            vue.uproductos = data;
            //window.console.log(response.data);
            vue.loadingproductos = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingproductos = false;
          });
      },
      async getNits() {
        let vue = this;
        this.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/nits`,
          headers: {},
        };

        let response = await xaxios.request(config).then(response => response).catch(e=>e);
        let data = response.data.data;
          data.map((x) => {
            x.xtext = `${x.nro} [${x.tipo_facturacion}]`;
          });
          vue.nits = data;
          window.console.log(data);
          vue.loading = false; 
      },
      async getConceptoUnidad(idconcepto,unidad){
        // /esam/conceptopagounidadnegocio/conceptopago/{CONCEPTOID:[1-9][0-9]{0,8}}/unidadnegocio/{UNIDADNEGOCIOID:[1-9][0-9]{0,8}}/nit/{NITID:[1-9][0-9]{0,8}}
        let config = {
          method: 'get', 
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/conceptopago/${idconcepto}/unidadnegocio/${unidad}/nit/${this.xitem.nit_id}`,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        const vue = this;
        await xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log('getconcepto response>>>', data);

            // vue.nuevo.actividad_economica_sin = data.codigo_actividad;
            vue.nuevo.actividad_economica_sin = vue.uactividades.find(a=>a.codigo==data.actividad_economica_sin);
            if(data.codigo_sin) vue.nuevo.codigo_sin = parseInt(data.codigo_sin);
            vue.nuevo.codigo_documento_sector = data.codigo_documento_sector;

            // window.console.log(vue.nuevo,'****---****', vue.nits);
            vue.nit_sel = vue.nits.find(n=>n.id==data.nit_id);
            vue.setNitDefault();
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },
      async setNitDefault(){
        let existe = this.nits.find(n=>n.apikey == this.$store.getters.getApiKey);
        window.console.log('nit ',existe);
      },
      save() {
        this.msg = '';
        let copia = JSON.parse(JSON.stringify(this.nuevo));
        let caja = this.$refs.refBuscarCaja.getSelected();
        // if(!caja) this.msg = 'Seleccione la cuenta netsuite';
        // else copia.cuenta_netsuite_id = caja.id;
        if(caja) copia.cuenta_netsuite_id = caja.id;

        if (!copia.concepto_pago_id) this.msg = 'No hay el concepto.';
        if (!copia.unidad_negocio_id) this.msg = 'Seleccione una unidad de negocio';
        if (!copia.cuenta_contable) this.msg = 'Ingrese la cuenta contable.';
        if (!copia.descripcion_cuenta_contable) this.msg = 'Ingrese la descripcion de cuenta contable.';
        // if (!this.nuevo.actividad_economica_sin) this.msg = 'Seleccione la actividad.';
        // if (!copia.codigo_sin) this.msg = 'Seleccione el codigo producto.';
        // if (!copia.codigo_documento_sector) this.msg = 'Seleccione el documento sector.';
        if(!this.nit_sel) this.msg = 'Seleccione el nit';
        else copia.nit_id = this.nit_sel.id;

        // window.console.log('......',JSON.stringify(copia,null,2), caja);
        if (this.msg) return;

        if(this.nuevo.actividad_economica_sin){
          copia.actividad_economica_sin = parseInt(this.nuevo.actividad_economica_sin);
          if(!copia.actividad_economica_sin){
            copia.actividad_economica_sin = parseInt(this.nuevo.actividad_economica_sin.codigo);
          }
        }


        //copia.actividad_economica_sin = parseInt(this.actividad.codigo),
        //copia.codigo_sin = parseInt(this.prod_sel); 

        /* let a = 5;
        window.console.log(JSON.stringify(copia,null,2));
        if(a > 1 ) return; */

        this.loading = true;
        let metodo = 'post';
        if (this.isedit) metodo = 'put';
        let vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio`,
          headers: {
            //apikey: '4265269017',
            'Content-Type': 'application/json',
          },
          data: copia,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('save:', data);
            if (data.data) {
              vue.msg = `${data.data}`;
            }
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
            vue.$emit('onsave');
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error.response);
            vue.loading = false;
            let data = error.response.data;
            if (typeof data == 'string') vue.msg = `${data}`;
            else {
              window.console.log(data);
              let mensaje = data.mensaje;
              if (data && data.data) vue.msg = data.data;
              if (mensaje || data.detalles) vue.msg = `Error ${mensaje}`;
              else if(data[0]) vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;
              else vue.msg = `${JSON.stringify(data)}`;
            }
          });
      },
    },
  };
</script>
